import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Input,
  Row,
  Col,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import { URL } from "../../api"; 
import axiosInstance from "../../Request";
import { useParams } from "react-router-dom";

const Profile = () => {
  const { cid , lid } = useParams();
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [responseMessage, setResponseMessage] = useState("");


 useEffect(() => {
  const fetchComments = async () => {
    try {
      const response = await axiosInstance.get(`${URL.GET_COMMENTS}?customer_id=${cid}&lead_id=${lid}`);
      const data = response.data;

      const filteredComments = (data || []).filter(
        (comment) =>
          (comment.comment_type === 2 || comment.comment_type === 3) &&
          comment.customer_id?.toString() === cid?.toString() &&
          comment.lead_id?.toString() === lid?.toString()
      );

      setComments(filteredComments);
    } catch (error) {
      console.error("Failed to fetch comments", error);
      setComments([]);
    }
  };

  fetchComments();
}, [cid, lid]);


  return (
    <>
      <Card className="bg-secondary shadow">
        <CardHeader className="bg-white border-0">
          <Row className="align-items-center">
            <Col xs="8">
              <h3 className="mb-0">Comments</h3>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          {/* New Comment Input */}
          <Row>
            <Col lg="12" className="mb-4">
              <label className="form-control-label" htmlFor="input-comment">
                New Comment:
              </label>
              <Input
                className="form-control-alternative"
                id="input-comment"
                placeholder="Comment"
                type="textarea"
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
              />
            </Col>
            <Col lg="12" className="mb-4 text-end">
            <Button
        color="primary"
        onClick={async (e) => {
            e.preventDefault();
            const user_id = localStorage.getItem("user_id");

            if (!newComment.trim() || !user_id) {
              setResponseMessage("Comment or User ID missing");
              return;
            }

            const payload = {
              customer_id: cid,
              lead_id: lid,
              comment: newComment.trim(),
              comment_type: 3,
              comment_by: user_id,
            };

            try {
              const res = await axiosInstance.post(URL.ADD_COMMENTS, payload);

              const result = res.data;

              setResponseMessage(result.message || "Comment added successfully");
              setNewComment("");

              // Refetch comments
              const commentsRes = await axiosInstance.get(`${URL.GET_COMMENTS}?customer_id=${cid}&lead_id=${lid}`);
              const data = commentsRes.data;

              const filtered = (data || []).filter(
                (comment) =>
                  (comment.comment_type === 2 || comment.comment_type === 3) &&
                  comment.customer_id?.toString() === cid?.toString() &&
                  comment.lead_id?.toString() === lid?.toString()
              );

              setComments(filtered);
            } catch (err) {
              console.error("Error:", err);
              setResponseMessage("An error occurred while adding comment.");
            }

            setTimeout(() => setResponseMessage(""), 4000);
          }}
      size="md"
        >
          Submit
        </Button>
        {responseMessage && (
          <p style={{ color: responseMessage.toLowerCase().includes("success") ? "green" : "red", fontWeight: "500" }}>
            {responseMessage}
          </p>
        )}
            </Col>
          </Row>
        <Row>
          {/* Comments List */}
         {comments.length > 0 ? (
        comments.map((comment, idx) => (
          <Col lg="12" className="mb-4" key={idx}>
            <div className="comment_w">
              <div className="mb-1" style={{ fontWeight: "500", fontSize: "14px" }}>
                Date : {comment.create_date} &nbsp;|&nbsp;
                By : {comment.commented_by_username || "N/A"} &nbsp;|&nbsp;
                {comment.comment_type_value || "-"} &nbsp;|&nbsp;
                {comment.status_value || "-"}
              </div>
              <p className="comment-text" style={{ marginBottom: "0", fontSize: "15px" }}>
                {comment.comment}
              </p>
            </div>
                </Col>
        ))
      ) : (
        <Col lg="12">
          <p>No comments found.</p>
        </Col>
      )}
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default Profile;
